const Theme={
	Header: "Montserrat",
	HeaderWeight: "300",
	Subheader: "Cardo",
	Description: "Yrsa",
	HeaderSize: "3.5rem",
	SubheaderSize: "2.5rem",
	DescriptionSize: "2rem",
	SmallDescriptionSize: "1.5rem",
	LargeHeaderSize: "9rem",
	LogoSize: "2rem",
	FooterSize: "0.8rem",
	Dark: "#3b3b3b",
	White: "#fff",
	Grey: "#ccc",
	Primary: "#009FB7",
	Secondary: "#f5f5f5",
	Special: "#1150A7",
	LargeButtonSize: "2rem",
	ButtonSize: "1.5rem",
	SmallButtonSize: "1rem",
	FormLabelWeight: "600",
	FooterWeight: "400",
	NextButton: "#0275d8",
	BackButton: "#CF0820"
}

export default Theme
